export default __webpack_public_path__ + "static/media/network-graph-2-rMIN.b243f50c.jpg";